import React, { useState, useEffect } from "react";
import ReBiddingDialog from "../../molecules/ReBiddingDialog";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import RadioGroup from "../../atoms/RadioGroup";
import { updatedListedProjectCreditsApi } from "../../../utils/API/updatedListedProjectCredits";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { taxationAmount } from "../../../utils/API/taxationAmount";
import toast from "react-hot-toast";

const status = [
  { label: "Partially", value: "partially" },
  { label: "Fully", value: "fully" },
];

const ModifyBid = ({
  open,
  onOk,
  onCancel,
  onModify,
  selectedRowData,
  selectedColumns,
}) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState([]);
  const [noOfCredits, setNoOfCredits] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("partially");
  const [pricePerCredit, setpricePerCredit] = useState(null);
  const [creditsErrorMsg, setCreditsErrorMsg] = useState("");
  const [priceErrorMsg, setPriceErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [remittance, setRemittance] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const previousNoOfCredits =
    selectedRowData && selectedRowData["No. of credits"];
  const previousPricePerCredit =
    selectedRowData && selectedRowData["Listed Price"];

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
    if (event.target.value === "fully") {
      setNoOfCredits(selectedRowData["No. of credits"]);
    } else {
      setNoOfCredits(null);
    }
  };

  const handleNumberOfCreditsChange = (event) => {
    const inputCredits = parseInt(event.target.value, 10);
    if (inputCredits > 0) {
      setNoOfCredits(inputCredits);
      setCreditsErrorMsg("");
    } else {
      setNoOfCredits("");
      setCreditsErrorMsg("Number of credits should be greater than 0");
    }
  };

  const handlePricePerCreditChange = (event) => {
    const inputPrice = parseFloat(event.target.value);
    if (inputPrice > 0) {
      setpricePerCredit(inputPrice);
      setPriceErrorMsg("");
    } else {
      setpricePerCredit("");
      setPriceErrorMsg("Price per credit should be greater than 0");
    }
  };
  const handleOk = async () => {
    if (pricePerCredit <= 0 || noOfCredits <= 0) {
      if (pricePerCredit <= 0) {
        setPriceErrorMsg("Price per credits should be greater than 0");
      }
      if (noOfCredits <= 0) {
        setCreditsErrorMsg("Number of credits should be greater than 0");
      }
    } else {
      try {
        setLoading(true);

        await updatedListedProjectCreditsApi(
          {
            projectId: selectedRowData["Project Id"],
            pricePerCredit: parseInt(pricePerCredit),
            creditsToSell: noOfCredits,
            creditTransaction: selectedStatus,
          },
          dispatch
        );
        setCreditsErrorMsg("");
        setPriceErrorMsg("");
        setNoOfCredits();
        setpricePerCredit();
        setSelectedStatus("partially");
        onModify();
      } catch (error) {
        console.error("Error editing bid:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCancel = () => {
    setCreditsErrorMsg("");
    setPriceErrorMsg("");
    setNoOfCredits("");
    setpricePerCredit("");
    setSelectedStatus("partially");
    onCancel();
  };
  useEffect(() => {
    if (
      noOfCredits &&
      pricePerCredit &&
      noOfCredits !== 0 &&
      pricePerCredit !== 0 &&
      noOfCredits !== "" &&
      pricePerCredit !== ""
    ) {
      fetchTaxationData();
    } else {
      setAmount(0);
      setGst(0);
      setPlatformFee(0);
      setRemittance(0);
      setTotalAmount(0);
    }
  }, [noOfCredits, pricePerCredit, selectedStatus]);

  const fetchTaxationData = async () => {
    try {
      const formData = {
        buyerOrigin: "NAT",
        sellerOrigin: "NAT",
        totalAmount: noOfCredits * pricePerCredit,
      };
      const amounts = await taxationAmount(formData, dispatch);
      setAmount(formData.totalAmount);
      setGst(amounts.data.data.tax);
      setPlatformFee(amounts.data.data.platform_fee);
      setRemittance(amounts.data.data.remittance);
      const calculatedTotalAmount =
        formData.totalAmount -
        (amounts.data.data.tax +
          amounts.data.data.platform_fee +
          amounts.data.data.remittance);
      setTotalAmount(calculatedTotalAmount);
    } catch (error) {
      toast.error("Error in Fetching Taxes and amounts Balance");
    } finally {
    }
  };

  return (
    <ReBiddingDialog
      open={open}
      onCancel={handleCancel}
      onOk={onOk}
      selectedRowData={selectedRowData}
      selectedColumns={selectedColumns}
    >
      <div className="pt-6">
        <div className="pl-8 ">
          <RadioGroup
            options={status}
            onChange={handleStatusChange}
            value={selectedStatus}
          />
        </div>
        <div className="flex pt-2 pr-10 text-base pb-2 ">
          <div className="w-40 pl-10 font-bold ">Previous Bid - </div>
          <div className="flex ml-16 gap-x-24 ">
            <div>No of Credits - {previousNoOfCredits}</div>
            <div>Price per credit - ${previousPricePerCredit}</div>
          </div>
        </div>

        <div className="flex font-bold pt-2 pr-10 text-base bg-blue-400  ">
          <div className="w-52 pl-10 ">New Bid - </div>
          <div className="flex ml-4 gap-x-20 ">
            <div className="flex">
              <span className="text-base  pr-1 font-bold">
                No of Credits -{" "}
              </span>
              <Input
                type="number"
                variant="secondary"
                className="inline-block text-base w-14"
                value={noOfCredits}
                onChange={handleNumberOfCreditsChange}
                placeHolder={0}
                disabled={selectedStatus === "fully" ? true : false}
              />
            </div>

            <div className="flex">
              <span className="text-base font-bold  pr-2">
                {" "}
                Price per credit -
              </span>
              <Input
                type="number"
                variant="secondary"
                className="inline-block text-base w-14 "
                value={pricePerCredit}
                onChange={handlePricePerCreditChange}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-between mx-8">
          <p className="text-red-500 text-sm">{creditsErrorMsg}</p>
          <p className="text-red-500 text-sm">{priceErrorMsg}</p>
        </div>
        <div className=" pl-12 pt-3 text-xs text-gray-400">
          <p className="py-1">Amount = ${amount?.toFixed(2)}</p>
          <p className="pb-1">Taxes(GST) = ${gst?.toFixed(2)}</p>
          <p className="pb-1">Remittance = ${remittance?.toFixed(2)}</p>
          <p className="pb-1">Platform Fee = ${platformFee?.toFixed(2)}</p>
        </div>
        <p className="pl-12 text-sm">
          Total Fund Earn - ${totalAmount?.toFixed(2)}
        </p>
      </div>
      <div className="flex justify-center gap-5">
        <Button
          varient="primary"
          borderColor="blue"
          className=" w-40 h-10 mt-4  mb-7 text-sm justify-center lg:py-2 text-white font-bold border-none  bg-blue-800 "
          onClick={handleOk}
          disabled={loading}
        >
          <div className="flex justify-center">
            {loading ? <LoadingOutlined /> : "Modify"}
          </div>
        </Button>
      </div>
    </ReBiddingDialog>
  );
};

export default ModifyBid;
